import { render } from "./VectorLeft.svg?vue&type=template&id=784a90ef"
const script = {}
script.render = render

export default script